import React, { useEffect, useState, useCallback } from 'react';
import { Routes, Navigate, Route } from 'react-router-dom';
import AuthPage from './pages/AuthPage';
import TokenPage from './pages/TokenPage';
import AuthHandle from './pages/AuthHandle';
import AuthRenew from './pages/AuthRenew';
import AuthLogout from './pages/AuthLogout';
import { StoreProvider, useStores } from './stores/context';
import { observer } from 'mobx-react-lite';
import FullPageLoader from './pages/FullPageLoader';

const RouteWrapper = observer(() => {
    const [ready, setReady] = useState(false);
    const { authStore } = useStores();
    const init = useCallback(async () => {
        await authStore.init();
    }, [authStore]);

    useEffect(() => {
        init().then(() => setReady(true));
    }, [init]);

    if (!ready) {
        return (
            <FullPageLoader /> 
        )
    }

    return !authStore.isLoggedIn ? (
        <Routes>
            <Route path="/auth" element={<AuthPage/>} />
            <Route path="/auth/logout" element={<AuthLogout/>} />
            <Route path="/auth/handle" element={<AuthHandle/>} />
            <Route path="*" element={<Navigate to="/auth"/>}/>
        </Routes>
    ) : (
        <Routes>
            <Route path="/auth/logout" element={<AuthLogout/>} />
            <Route path="/auth/renew" element={<AuthRenew/>} />
            <Route path="/auth/handle" element={<AuthHandle />} />
            <Route path="/auth/token" element={<TokenPage />} />
            <Route path="*" element={<Navigate to={authStore.getRootURIForUser()}/>} />
        </Routes>
    );
});
const App = () => {
    return (
        <StoreProvider>
            <RouteWrapper />
        </StoreProvider>
    );
};

export default App;
